import {Component} from 'react';
import h from 'react-hyperscript';
import {eyebrow} from 'Components/Typography/Typography';
import ListItem from './ListItem';

class List extends Component {
  render() {
    return (
      h('div', {
        className: `${this.props.className} list padding-bottom--md-2`,
      }, [
        h(eyebrow, {
          className: 'content__title',
        }, this.props.title),
        h('ol', null, this.props.items.map((item, i) => {
          return (
            h(ListItem, {
              item: item,
              index: i,
              resourceCategory: this.props.resourceCategory,
            }, null)
          );
        })),
      ])
    );
  }
}

export default List;
